import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { applicationService } from "../services/applicationService";

// Query keys for consistent cache management
export const applicationKeys = {
  all: ["applications"],
  lists: () => [...applicationKeys.all, "list"],
  list: (filters) => [...applicationKeys.lists(), { filters }],
  details: () => [...applicationKeys.all, "detail"],
  detail: (id) => [...applicationKeys.details(), id],
};

// Custom hooks for applications
export const useApplications = (options = {}) => {
  return useQuery({
    queryKey: applicationKeys.lists(),
    queryFn: applicationService.getApplications,
    ...options,
  });
};

export const useApplication = (id, options = {}) => {
  return useQuery({
    queryKey: applicationKeys.detail(id),
    queryFn: () => applicationService.getApplication(id),
    enabled: !!id,
    ...options,
  });
};

// Mutation hooks for applications
export const useCreateApplication = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: applicationService.createApplication,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: applicationKeys.lists() });
    },
  });
};

export const useUpdateApplication = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) =>
      applicationService.updateApplication(id, data),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: applicationKeys.lists() });
      queryClient.invalidateQueries({
        queryKey: applicationKeys.detail(variables.id),
      });
    },
  });
};

export const useDeleteApplication = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: applicationService.deleteApplication,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: applicationKeys.lists() });
    },
  });
};
